import { config } from "@/config";
import { posthogEventEmitter } from "@/lib/posthog/posthogEventEmitter";

interface GtagEventParams {
	action: string;
	category: string;
	label?: string;
	value?: string | number;
	partner_id?: number;
	provider_id?: number;
	email?: string;
	[key: string]: unknown;
}

/**
 * Emit a Google Analytics event AND send to PostHog.
 * PostHog always fires. GA is skipped for China app (Google blocked).
 */
export const gtagEventEmitter = ({
	action,
	category,
	label = "",
	value = "",
	...args
}: GtagEventParams): void => {
	// 1. ALWAYS send to PostHog (regardless of China/global)
	if (action) {
		posthogEventEmitter({
			action,
			category,
			label,
			value,
			...args,
		});
	}

	// 2. Skip gtag for China (Google blocked)
	if (config.global.isChinaApp) {
		return;
	}

	// 3. Send to Google Analytics
	if (
		typeof window !== "undefined" &&
		typeof window.gtag !== "undefined" &&
		action
	) {
		window.gtag("event", action, {
			event_category: category,
			...(label && { event_label: label }),
			...(value && { value }),
			...args,
		});
	}
};

/**
 * Emit a Google Analytics event with a 10ms delay to prevent duplicates
 */
export const gtagDuplicateEventEmitter = (eventObj: GtagEventParams): void => {
	setTimeout(() => gtagEventEmitter(eventObj), 10);
};
